import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

export default new vuex.Store({
  state: {
    windowHeight: '',
    isCollapse: false,
    navBarWidth: 256,
    rightAreaWidth: '',
    navBarActive: {},
    defaultActive: '1',
    userInfo: {},
    outputSuccessShowTab: '',
    currentLevelMap: 'country', // country,province,city,area,company
    currentLocationMap: '广东',

    /**生产列表相关参数 */
    comTypeList: [  // 设备参数-通讯方式列表：1-有线，2-4g，3-wifi，4nb卡
      {
        label: '有线',
        value: 1
      },
      {
        label: '4g',
        value: 2
      },
      {
        label: 'wifi',
        value: 3
      },
      {
        label: 'nb卡',
        value: 4
      },
    ], 
    serverTypeList: [ // 地址参数设置-连接地址列表： 0未设置 1mqtt 2中转 3、4.0S
      {
        label: 'mqtt',
        value: 1
      },
      {
        label: '中转',
        value: 2
      },
      {
        label: '4.0s',
        value: 3
      },
    ], 
  },
  mutations: {
    // 可视屏幕高度
    windowHeight(state, value) {
      state.windowHeight = value
    },
    // 右边区域宽度
    rightAreaWidth(state, value) {
      state.rightAreaWidth = value
    },
    // 侧边栏是否折叠，true为折叠，false为展开
    isCollapse(state,value) {
      state.isCollapse = value
    },
    // 侧边导航栏宽度
    navBarWidth(state, value) {
      state.navBarWidth = value
    },
    // 已选导航栏
    navBarActive(state, value) {
      state.navBarActive = value
    },
    // 默认上次选择二级菜单
    defaultActive(state, value){
      state.defaultActive = value
    },
    // 登录成功后显示页面
    userInfo: function (state, value) {
      state.userInfo = value
    },
    // 设备管理 - 生产列表 - 出库成功后，返回生产列表显示tab
    outputSuccessShowTab: function (state, value) {
      state.outputSuccessShowTab = value
    },
    // 地图
    saveCurrentLevelMap(state, value) {
      state.currentLevelMap = value
    },
    saveCurrentLocationMap(state, value) {
      state.currentLocationMap = value
    },

    /** 生产列表相关参数 */
    comTypeList(state, value) {
      state.comTypeList = value
    },
    serverTypeList(state, value) {
      state.serverTypeList = value
    },
  }

})




// WEBPACK FOOTER //
// ./src/store/index.js